import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import Button from '@material-ui/core/Button';
import styles from './retry.module.scss';

export default memo(function Retry(props) {
    const { t } = useTranslation(['common', 'validations']);
    const handleClick = () => props.retry(props.payload);

    return (
        <div className={styles.errorContainer}>
            <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
            <span>{t('validations:ERROR')}</span>
            <Button variant="contained" onClick={handleClick}>{t('common:RETRY')}</Button>
        </div>
    )
}, (prevProps, nextProps) => prevProps.payload === nextProps.payload);
